import React from 'react';
import { FormContainer } from 'containers/forms/Form';
import { RichText } from 'components/rich-text/RichText';

export const FormSlice = ({
  title,
  text,
  formId,
  messageTitle,
  message,
  items,
  ageCheck,
  isSlice,
  isSplitPage,
}) => {
  return (
    <FormContainer
      // tagline={tagline}
      title={title}
      text={RichText.render(text)}
      messageTitle={messageTitle}
      message={RichText.render(message)}
      formId={formId}
      formData={items}
      ageCheck={ageCheck}
      isSlice={isSlice}
      isSplitPage={isSplitPage}
    />
  );
};

export default FormSlice;
